import React, { useState, useEffect, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { SpeedometerChart } from '../Charts';
import { TextContainer } from './';
import { OnScrollWrapper } from '../UtilityWrappers';
import { isFieldValid } from '../../utils/validation';
import media from '../../utils/media';
const GraphicContainer = styled.div `
  background-color: ${({ theme }) => theme.primaryWhite};
  section {
    border-bottom: 1px solid ${({ theme }) => theme.greyDarkMedium};
  }
`;
const ItemContainer = styled.section `
  display: flex;
  max-width: 540px;
  padding: 30px 0px 30px 60px;

  ${media.tablet} {
    padding: 30px 0px 30px 30px;
  }

  ${media.mobile} {
    padding: 30px 0px 30px 0px;
    display: flex;
    flex-direction: column;
  }
`;
const StyledSpeedometerContainer = styled.div `
  ${media.mobile} {
    margin: 0px auto 10px;
  }
`;
export const SpeedometerGraphic = ({ fields }) => {
    const [isComponentVisible, setIsComponentVisible] = useState(false);
    const [shouldInitiateAnimation, setShouldInitiateAnimation] = useState(false);
    if (!fields) {
        return null;
    }
    useEffect(() => {
        if (isComponentVisible) {
            setTimeout(() => {
                setShouldInitiateAnimation(true);
            }, 1000);
        }
    }, [isComponentVisible]);
    const themeContext = useContext(ThemeContext);
    const { isWindowMobile, speedometerSingleDesktopItem = {}, graphSectionRendersOneChild } = themeContext;
    const { fontSize, dimensions, strokeWidth } = speedometerSingleDesktopItem;
    const { chartValue, graphicTitle, graphicBodyText } = fields;
    return (
    // className conventions is used for styling by InfographicContianer
    React.createElement(GraphicContainer, { className: "graphic-container", "data-testid": "graphic-container" },
        React.createElement(OnScrollWrapper, { onVisibilityChange: setIsComponentVisible, isPartiallyVisible: true },
            React.createElement(ItemContainer, { className: "item-container speedometer" },
                isFieldValid(chartValue) && (React.createElement(StyledSpeedometerContainer, { className: "speedometer-container" },
                    React.createElement(SpeedometerChart, { newValue: chartValue.value, initiateAnimation: shouldInitiateAnimation, dimensions: graphSectionRendersOneChild && !isWindowMobile ? dimensions : undefined, strokeWidth: graphSectionRendersOneChild && !isWindowMobile ? strokeWidth : undefined, fontSize: graphSectionRendersOneChild && !isWindowMobile ? fontSize : undefined }))),
                React.createElement(TextContainer, { bodyText: graphicBodyText, title: graphicTitle })))));
};
